
window.onload = () => {
  const setShareLinks = () => {
      const shareLinks = document.querySelectorAll(".social-sharing__link");
      shareLinks.forEach(el => {
          el.addEventListener("click", event => {
              event.preventDefault();
              const url = el.getAttribute("href");
              socialWindow(url);
          });
      });
  };

  const socialWindow = (url) => {
      const left = (screen.width - 570) / 2;
      const top = (screen.height - 570) / 2;
      const params = `menubar=no,toolbar=no,status=no,width=570,height=570,top=${top},left=${left}`;
      window.open(url, "NewWindow", params);
  };

  const setNativeShare = () => {
      /* Os botoes com data-share-card-open abrem o card de story e sao tratados
       * por share-card.js; aqui ficam apenas os que compartilham titulo e link. */
      const buttons = document.querySelectorAll(".share-button__native:not([data-share-card-open])");
      if (!navigator.share) return;
      buttons.forEach(el => {
          el.removeAttribute("hidden");
          el.addEventListener("click", async () => {
              try {
                  await navigator.share({
                      title: el.dataset.shareTitle || document.title,
                      url: el.dataset.shareUrl || window.location.href,
                  });
              } catch (e) {
                  /* usuário cancelou ou não suportado */
              }
          });
      });
  };

  setShareLinks();
  setNativeShare();
};
